import React from 'react';
import PropTypes from 'prop-types';

import SaveCircleButton from '../../button/SaveButton';
import useInput from '../../../utils/common/customHook';

import {
  CreateThread,
  DivThreadAction,
  DivThreadBody,
  DivThreadInput,
  InputThreadList,
} from '../../styled';
import {
  PLACEHOLDER_TITLE_ADD_THREAD,
  PLACEHOLDER_TITLE_ADD_THREAD_EN,
  PLACEHOLDER_TITLE_BODY_THREAD,
  PLACEHOLDER_TITLE_BODY_THREAD_EN,
} from '../../../utils/common/constant';

const FormCreateThread = ({ createThread }) => {
  const [title, onTitleChange] = useInput('');
  const [body, onBodyChange] = useInput('');
  const locale = 'en';

  const createthread = () => {
    if (body.trim()) {
      createThread({ title, body });
    }
  };

  return (
    <CreateThread>
      <DivThreadInput>
        <InputThreadList
          placeholder={locale === 'id' ? PLACEHOLDER_TITLE_ADD_THREAD : PLACEHOLDER_TITLE_ADD_THREAD_EN}
          value={title}
          onChange={onTitleChange}
        />
        <DivThreadBody
          data-placeholder={locale === 'id' ? PLACEHOLDER_TITLE_BODY_THREAD : PLACEHOLDER_TITLE_BODY_THREAD_EN}
          contentEditable
          onInput={onBodyChange}
          data-testid="thread"
        />
      </DivThreadInput>

      <DivThreadAction>
        <SaveCircleButton onAdd={createthread} />
      </DivThreadAction>
    </CreateThread>
  );
};

FormCreateThread.propTypes = {
  createThread: PropTypes.func.isRequired,
};

export default FormCreateThread;
